import { Component } from '@angular/core';

import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'general-error-page',
  templateUrl: 'general.html',
})
export class GeneralErrorPage {

  constructor(
    public errorService: ErrorService
  ) {

  }

}



// WEBPACK FOOTER //
// ./src/pages/error/general.ts